// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import qs from 'qs'
import 'lib-flexible'
import '../vue.config'
import Apple from './Apple.vue'
import router from './router'
import Vuex from 'vuex'
import plupload from 'plupload'
import store from './store/store'
import ElementUI, { Carousel, Message, Input, Select, Upload, Dropdown, Timeline, Progress, Table } from 'element-ui';
import pdf from 'vue-pdf'
import '../node_modules/swiper/css/swiper.css'
import '@babel/polyfill'


Vue.prototype.$qs = qs;
// 全局AIPURL
Vue.prototype.$apiUrl = "http://ke.yunlearning.com:8081";
// Vue.prototype.$apiUrl = "http://192.168.1.10";

if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    window.location.href = "http://m.yunlearning.com";
} else {
    //如果是PC端就跳转打开PC端页面
    // location = 'http://ke.yunlearning.com';
}

Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 };
if (module.hot) { //解决wds一直请求的bug
    module.hot.accept();
}
// /* eslint-disable no-new */
Vue.use(ElementUI);
Vue.use(Carousel);
Vue.use(Input);
Vue.use(Select);
Vue.use(Upload);
Vue.component(Message.name, Message);
Vue.use(Dropdown);
Vue.use(Timeline);
Vue.use(Vuex)
Vue.use(plupload)
Vue.use(Progress);
Vue.use(Table);
Vue.config.productionTip = false;

new Vue({
    el: '#apple',
    router,
    components: { Apple },
    template: '<Apple/>',
    store: store,
    render: h => h(Apple)

})



// WEBPACK FOOTER //
// ./src/main.js